__webpack_require__.p = "/qa/en/customer-service/returns-claims/spareparts/";